import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    financialCoinTypeList: [],
    editingProject: null,
    interestInfo:false
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload.data;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setInterestInfo(state, payload) {
      state.interestInfo = payload;
    },
    setFinancialCoinTypeList(state, payload) {
      state.financialCoinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    getInterest({commit}, data) {
      return api.getInterest().then(res=>{
        commit('setInterestInfo',res.data)
      });
    },
    setInterest({commit}, data) {
      return api.setInterest(data).then(res=>{
        return res
      });
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    getFinancialCoinTypeList({ commit }) {
      api.getFinancialCoinTypeList().then(({ data }) => {
        commit('setFinancialCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    createTest(context, data) {
      return api.createTest(data);
    }
  }
};

appStore.registerModule('cornucopia', store);
